import { View, TouchableOpacity, Pressable, Modal, StyleSheet } from 'react-native';
import { Button, Text } from 'react-native-elements';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18n-js';
import { isIos } from '../../common/utils/platform.utils';
import { useNavigation } from '@react-navigation/native';
import theme from '../../common/ui/theme';

export const ConfirmVerifyDocument = ({ title, message, modalVisible, setModalVisible, webNavigation, navigationPage }) => {
    const navigation = useNavigation();

    return (
        <Modal
            animationType="fade"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
                setModalVisible(false);
            }}
        >
            <Pressable style={[isIos ? theme.styles.iosBackdrop : theme.styles.androidBackdrop, theme.styles.backdrop]} onPress={() => setModalVisible(false)} />
            <View style={styles.alertBox}>
                <View style={[styles.innerAlertBox]}>
                    <Text style={[styles.modalTitle]}>{title}</Text>
                    <Text style={[styles.modalMessage]}>{message}</Text>
                    <Button
                        buttonStyle={theme.styles.buttonStylePrimary}
                        titleStyle={theme.styles.titleStylePrimary}
                        title={i18n.t('pages.documentVerify.confirmDocument.skipNow')}
                        onPress={() => {
                            setModalVisible(false);
                            navigation.push('Onboarding.AccountSelection')
                        }}
                    />
                    <TouchableOpacity style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onPress={() => { console.log("Socure initialize"); webNavigation(navigationPage) }}>
                        <Text style={{
                            fontFamily: 'DMSans_700Bold',
                            color: "#00008E",
                            fontSize: 14,
                            lineHeight: 24,
                            textAlign: 'center',
                            textDecorationLine: 'underline',
                            marginTop: 10
                        }}>
                            {i18n.t('pages.documentVerify.confirmDocument.verfiyDocument')}
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    alertBox: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 16
    },
    innerAlertBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 24,
        borderRadius: 20,
        backgroundColor: theme.colors.shadWhite,
    },
    modalTitle: {
        fontFamily: 'DMSans_700Bold',
        fontSize: 24,
        lineHeight: 32,
        textAlign: 'center',
        color: theme.colors.phthaloBlue,
        marginBottom: 16
    },
    modalMessage: {
        fontFamily: 'DMSans_400Regular',
        fontSize: 16,
        lineHeight: 19,
        textAlign: 'center',
        marginBottom: 16
    }
});

ConfirmVerifyDocument.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    modalVisible: PropTypes.bool,
    setModalVisible: PropTypes.func,
    webNavigation: PropTypes.any,
    navigationPage: PropTypes.any
};